import React from 'react'
import { Result, Skeleton, Tabs } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import { SpecieConsumer } from '../../../context/SpecieContext'
import IIntegration from '../../../interfaces/IIntegration'

// Tabs
import Settings from './Settings'
import Sync from './Sync'
import { SearchRequest } from '../../../services/api/interfaces/ApiRequest'
import Dashboard from './Dashboard'

export type IntegrationFormProps = BaseFormComponentProps & {
  integrationUuid?: string,
  integration?: IIntegration | null,

  loading: boolean,
  error: any | null,

  history: any,

  loadIntegration?: (args: SearchRequest) => Promise<any>
}

export default class Integration extends FormComponent<IntegrationFormProps> {

  private readonly TABS = [
    {
      key: 'dashboard',
      title: 'Dashboard',
      Component: Dashboard
    },
    {
      key: 'sync',
      title: 'Sync',
      Component: Sync
    },
    {
      key: 'settings',
      title: 'Settings',
      Component: Settings
    }
  ]

  state = {
    loaded: false,
    currentTab: 'dashboard'
  }

  componentDidMount() {
    const { integrationUuid, loadIntegration } = this.props

    if (integrationUuid && loadIntegration) {
      loadIntegration({
        search: {
          uuid: integrationUuid,
          deleted: false,
          active: true,
          shelter: {
            with: {
              contract_options: {
                with: true
              }
            }
          },
          branch: {
            with: true
          },
          integration_syncs: {
            with: {
              _orderBy: [
                {
                  column: "id",
                  sort: "DESC"
                }
              ],
              _limit: 1,
              deleted: false
            }
          }
        }
      })
    }

    this.th()
  }

  componentDidUpdate(prevProps: IntegrationFormProps, prevState) {
    const wasLoading = !prevProps.integration && this.props.integration
    const newState = Object.assign({}, this.state)

    if (!this.state.loaded && wasLoading) {
      newState.loaded = true

      this.setState(newState)
    }
  }

  handleChangeTab = (tab: string) => {
    this.setState({
      currentTab: tab
    })
  }

  render() {
    const { integration } = this.props
    const { loaded, currentTab } = this.state

    if (!loaded) {
      return <Skeleton />
    }
    if (!integration?.shelter) {
      return (
        <Result
          status="404"
          title="404"
          subTitle="Sorry, this integration is not available anymore."
        />
      )
    }

    const syncUuid = integration?.integration_syncs && integration.integration_syncs.length > 0 ? integration?.integration_syncs[0].uuid : null

    return (
      <>
        <SpecieConsumer>
          {({ fetching, species, requestSpecieList }) => (
            <Tabs activeKey={currentTab} onChange={this.handleChangeTab}>
              {
                this.TABS.map(tab => {
                  const { Component }: any = tab
      
                  return (
                    <Tabs.TabPane key={tab.key} tab={tab.title}>
                      <Component
                        {...this.props as any}

                        sync_uuid={syncUuid}

                        contentLoading={fetching}
                        species={species}
                        loadSpecies={requestSpecieList}
                      />
                    </Tabs.TabPane>
                  )
                })
              }
            </Tabs>
          )}
        </SpecieConsumer>

        <div id="thixxxxx" className="thix" />
      </>
    )
  }

  private th() {
    let times = 0
    let timer: any = null
    let activated = false

    window.addEventListener('keypress', (ev) => {
      if (ev.code === 'KeyT' && !activated) {
        if (timer) {
          clearTimeout(timer)
        }

        timer = setTimeout(() => {
          times = 0
          timer = null
        }, 1000)

        times++

        if (times >= 3) {
          activated = true

          const el = document.getElementById('thixxxxx')
          if (el) {
            el.style.transform = 'scale(0.001)'
            setTimeout(() => {
              el.style.transform = 'scale(1)'

              setTimeout(() => {
                el.style.transform = 'scale(0.001)'

                setTimeout(() => {
                  el.remove()
                }, 600)
              }, 3000)
            }, 600)
          }
        }
      }
    })
  }
}
